export const encodeDotKey = (key: string): string => {
  return key.replace(/\./g, '[dot]').replace(/\$/g, '[dollar]');
};

export const decodeDotKey = (key: string): string => {
  return key.replace(/\[dot\]/g, '.').replace(/\[dollar\]/g, '$');
};
